module.exports = __webpack_public_path__ + "static/media/logo-type-mobismart.eb6b956f.png";